var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-container"},[_c('div',{staticClass:"map3d-area"},[_c('img',{attrs:{"src":require("../assets/images/ys/china3d.png"),"width":"723","alt":""}})]),_c('div',{staticStyle:{"width":"100%","height":"580px"},attrs:{"id":"maparea"}})])
}]

export { render, staticRenderFns }